"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EStaticFileType = exports.EFileSection = void 0;
var EFileSection;
(function (EFileSection) {
    EFileSection["VEHICLE"] = "vehicle";
    EFileSection["TASK"] = "tasks";
    EFileSection["STATIC"] = "static";
    EFileSection["OPPORTUNITY"] = "opportunity";
    EFileSection["TEMPLATE"] = "template";
})(EFileSection = exports.EFileSection || (exports.EFileSection = {}));
var EStaticFileType;
(function (EStaticFileType) {
    EStaticFileType["PROFILE_IMAGE"] = "profile_image";
    EStaticFileType["VEHICLE_IMAGE"] = "vehicle_image";
    EStaticFileType["OFFER"] = "offer";
    EStaticFileType["PANORAMIC_IMAGE"] = "panoramic_image";
    EStaticFileType["TEMPLATE_APPENDIX"] = "template_appendix";
    EStaticFileType["BATTERY_CERTIFICATE"] = "battery_certificate";
})(EStaticFileType = exports.EStaticFileType || (exports.EStaticFileType = {}));
